import React from 'react';
import {useSelector} from 'react-redux';
import './NotEnoughFactionsModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import QuestsButton from '../../elements/QuestsButton/QuestsButton';
import {getFreeFactionOffer} from '../../../utils/factions/getFreeFactionOffer';
import {getFactionIconPath} from '../../../utils/factions/getFactionIconPath';

const PAGE_ID = 'NotEnoughFactionsModal';

/**
 * Отказ в рейтинговом матче: фракций меньше четырех. Кроме заданий и
 * магазина подсказывает про фракцию, которую сейчас можно забрать в магазине
 * бесплатно по акции (см. getFreeFactionOffer) — если она у игрока еще не
 * открыта. Выпускнику обучения после первого сетевого матча до четырех
 * фракций как раз ее и не хватает
 */
function NotEnoughFactionsModal({availableCount, onGoToQuests, onGoToShop, onHide}) {
  const availableFactions = useSelector((state) => state.private.auth.availableFactions);
  const freeFactionOffer = getFreeFactionOffer(availableFactions);

  return (
    <div className="not-enough-factions-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="not-enough-factions-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="not-enough-factions-title">Недостаточно фракций</h2>
        <p className="not-enough-factions-text">
          Для участия в <span className={'text-crystals'}>рейтинговой игре</span> необходимо октрыть минимум <span className={'text-coins'}>4</span> фракции.
        </p>
        <p className="not-enough-factions-count">
          Сейчас у тебя открыто фракций: <span className={'text-coins'}>{availableCount}</span>
        </p>
        <p className="not-enough-factions-text">
          Открыть недостающие фракции можно,
          <br/>выполнив простые стартовые задания.
          <br/>Или купить фракции в Магазине.
        </p>
        {freeFactionOffer && (
          <p className="not-enough-factions-text not-enough-factions-free-offer">
            <img
              className="not-enough-factions-free-offer_icon"
              src={getFactionIconPath(freeFactionOffer.id)}
              alt={freeFactionOffer.name}
            />
            <span>
              А фракцию <span className={'text-coins'}>{freeFactionOffer.name}</span> сейчас можно
              забрать в Магазине <span className={'text-coins'}>бесплатно</span> — предложение временное!
            </span>
          </p>
        )}
        <div className="main-menu-buttons not-enough-factions-buttons">
          {/* Задания — тот же вид и та же логика, что у кнопки в профиле */}
          {onGoToQuests && <QuestsButton onClick={onGoToQuests} pageId={PAGE_ID}/>}
          <PageButton
            className={'main-menu-button_shop'}
            onClick={onGoToShop} pageId={PAGE_ID} buttonId="go_to_shop"
          >
            В магазин
          </PageButton>
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide">
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default NotEnoughFactionsModal;
